<template>
    <section class="mt-4">
        <h3 class="mx-4 p-4 text-lg font-bold">History</h3>
        <table class="w-full table-fixed">
            <thead>
                <tr class="border border-gray-light bg-gray-light">
                    <th class="w-3/12 uppercase text-xs text-left px-8 py-3">Date</th>
                    <th class="w-6/12 hidden md:inline-block uppercase text-xs text-left px-4 py-3">Invoice ID</th>
                    <th class="w-2/12 uppercase text-xs text-right px-4 py-3">Amount</th>
                    <th class="w-1/12 text-xs text-center px-4 py-3"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="border border-bottom border-gray-light" v-for="invoice in invoices" :key="invoice.id">
                    <td class="px-8 py-2">{{ invoice.date }}</td>
                    <td class="hidden md:inline-block px-4 py-2">{{ invoice.id }}</td>
                    <td class="px-4 py-2 text-right">{{ invoice.total }}</td>
                    <td class="px-4 py-2 text-center"><a :href="invoice.pdf_link"><font-awesome-icon :icon="['fas', 'download']" class="text-gray-darker text-sm"></font-awesome-icon></a></td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
export default {
    props: {
        invoices: {
            type: Array,
            required: true,
        },
    }
}
</script>